const FooterTexts = {
	backWarningMessage: 'The inputs entered will be lost',
	backText: 'Back',
	nextText: 'Next',
};

export default FooterTexts;
